module.exports = __webpack_public_path__ + "static/media/7c474dce-e4a3-4487-9d48-184609cbc49b.d725531e.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/7c474dce-e4a3-4487-9d48-184609cbc49b.jpg
// module id = 830
// module chunks = 0